/**
 * AnniversaryApi 的 codegen client 适配层。
 * - 复用 src/api/client.ts 的 axios 实例（已注入 X-User + 错误归一）
 * - 不让 codegen Configuration 重复注入 X-User，避免双重 header
 */
import { apiClient } from '../client'
import { AnniversaryApi } from '../generated'

export const anniversaryApi = new AnniversaryApi(undefined, '', apiClient)
